import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Fade + slide-up reveal on scroll into view
export const Reveal = ({ children, delay = 0, y = 34, className = "", once = true }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
      viewport={{ once, margin: "-12% 0px -12% 0px" }}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
};

// Masked line-by-line reveal for large headings. `lines` = array of strings.
// trigger: "view" (on scroll into view) or "load" (on mount, for above-the-fold).
export const MaskReveal = ({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.12, trigger = "view" }) => {
  const reduce = useReducedMotion();
  const hidden = reduce ? { opacity: 0 } : { y: "110%" };
  const shown = reduce ? { opacity: 1 } : { y: "0%" };
  const anim = trigger === "load"
    ? { animate: shown }
    : { whileInView: shown, viewport: { once: true } };
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            initial={hidden}
            {...anim}
            transition={{ duration: 0.95, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export { EASE };
